import { useMutation } from "@tanstack/react-query";
import { useAuth } from "../context/AuthContext";
import { env } from "../utils/env";
import { axios } from "./axios";

export const useDeleteMandate = () => {
  const { authHeader } = useAuth();

  return useMutation(({ id }: { id: number }) => {
    return axios.delete(`${env.verifyServiceUrl}individual/mandate/${id}/`, {
      headers: {
        Authorization: authHeader,
      },
    });
  });
};
